// Store gets configured with middleware and initial state

import {createStore, applyMiddleware, compose} from 'redux';

//promises
import promise from 'redux-promise';
// async stuff
import thunk from 'redux-thunk';
//AUTOMATICALLY LOGS ALL ACTION EVENTS colored + state
import logger from 'redux-logger';
//CHROME EXTENSION - https://github.com/zalmoxisus/redux-devtools-extension#usage
import { composeWithDevTools } from 'redux-devtools-extension';


//FETCH ALL REDUCERS TO LOAD
import rootReducer from '../reducers/reducers';

const enhancers = composeWithDevTools(
  //CREATING MIDDLEWARE
  applyMiddleware(
    // Middlewares, like `redux-thunk` that intercept or emit actions should come before
    thunk,
    promise,
    logger,
  ),

  // other store enhancers if any
)


export default (initialState) => {
  return createStore(rootReducer, initialState, enhancers);
};



// WEBPACK FOOTER //
// ./client/store/configure-store.js